/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import Accordion from './scripts/accordion';
import FormLightbox from './scripts/form-lightbox';
import PageStatus from './scripts/page-status';
import TextMediaGallery from './scripts/text-media-gallery';
import VideoHandling from './scripts/video-handling';
import EventDates from './scripts/event-dates';
import LottieAnimate from './scripts/lottie-animate';

const scripts = [
  PageStatus,
  VideoHandling,
  TextMediaGallery,
  FormLightbox,
  Accordion,
  EventDates,
  LottieAnimate
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    // Set global variable to indicate whether motions should be reduced
    window.prefersReducedMotion = !!(
      window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
      window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true
    );

    scripts.forEach(script => {
      script.init();
    });
  }
});
